import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-576d3c7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-section16167" }
const _hoisted_2 = { class: "summary-section16167__title" }
const _hoisted_3 = { class: "summary-section16167__choices" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary16167Section',
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("ul", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})